import React from 'react';
// interfaces
import { ReportItemConfig } from '../../models';
// styles
import s from './ReportBanner.scss';
// components
import normal from './ReportBanner.normal';

export const ReportBanner = () => {
    const configs: ReportItemConfig[] = [
        {
            'label': '网络监督专区欢迎监督如实举报',
            'link': 'http://news.sohu.com/s2013/fanfujubao/',
            'cover': '//statics.itc.cn/static/images/awesome/jubao02.gif',
        }, {
            'label': '学习强国',
            'link': 'https://www.xuexi.cn/',
            'cover': '//statics.itc.cn/static/images/awesome/xuexiqiangguo.png',
        }, {
            'label': '网警小课堂',
            'link': '//mp.sohu.com/profile?xpt=NDdhZWJhZWMtYjJlYS00YzlkLWI2ZWMtNGY2NjE3OTE1MWEx',
            'cover': '//statics.itc.cn/static/images/awesome/jubao11.png',
        }, {
            'label': '伟大的变革',
            'link': 'http://ggkf40.cctv.com',
            'cover': '//statics.itc.cn/static/images/awesome/jubao07.jpg',
        }, {
            'label': '社会主义核心价值观',
            'link': 'http://i2.itc.cn/20141216/26b_4594d163_880a_4ddc_d8a5_23b7ed2a23b3_1.jpg',
            'cover': '//statics.itc.cn/static/images/awesome/jubao03.gif',
        }, {
            'label': '网上有害信息举报专区',
            'link': 'http://www.12377.cn',
            'cover': '//statics.itc.cn/static/images/awesome/jubao05.gif',
        },
    ];
    return (
        <>
            <div className={`${s.container} party-container`}>
                {
                    normal({ config: configs })
                }
            </div>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/components/ReportBanner/index.tsx